
// components
import { ItemStatusTag } from "./item-status-tag";
import { SwapItemButton } from "./edit/swap-item";
import { FlagItemButton } from "./edit/flag-item";
import { DeleteItemButton } from "./edit/delete-item";
import { CardFooterLinkItem } from "shared/components/bulma/card";
import { CardFooter, CardFooterItem } from "shared/components/bulma/card";

// pipes
import { Ellipsis } from "shared/pipes/ellipsis";
import { ClipboardCopy } from "shared/pipes/clipboard-copy";

const TitleSection = ({ item }) => (
    <CardFooter>
        <CardFooterItem>
            <small>
                <span className="is-size-6" data-tooltip={`${item.name} (${item.barcode})`}>
                    <ClipboardCopy value={`${item.name} (${item.barcode})`}>
                        <Ellipsis tooltip={false}>
                            {item.name}
                        </Ellipsis>
                    </ClipboardCopy>
                </span>
            </small>
        </CardFooterItem>
    </CardFooter>
);

const ActionSection = ({ item, customer, box, onDelete, onSwap, onFlagged }) => (
    <CardFooter>
        <CardFooterItem>
            <SwapItemButton item={item} customer={customer} box={box} onSwap={onSwap} />
        </CardFooterItem>
        <CardFooterItem>
            <DeleteItemButton item={item} customer={customer} box={box} onDelete={onDelete} />
        </CardFooterItem>
        <CardFooterItem>
            <FlagItemButton item={item} customer={customer} box={box} onFlagged={onFlagged} />
        </CardFooterItem>
    </CardFooter>
);

const InfoSection = ({ item, box, withStatus = true }) => {
    const Status = () => {
        if (!withStatus) {
            return null;
        }

        return (
            <CardFooterItem>
                <ItemStatusTag item={item} box={box} />
            </CardFooterItem>
        );
    }

    return (
        <CardFooter>
            <CardFooterLinkItem className="has-text-link"
                path={`/products/${item.barcode}`}>
                <Ellipsis maxChars="8">
                    {item.barcode}
                </Ellipsis>
            </CardFooterLinkItem>

            <Status />
        </CardFooter>
    )
};

export { TitleSection, ActionSection, InfoSection };
